import template from './swag-cms-extensions-form-editor-settings-field-type-base.html.twig';

export default {
    name: 'swag-cms-extensions-form-editor-settings-field-type-base',
    template,
    computed: {
        field() {
            return Shopware.Store.get('swCmsDetailCurrentCustomForm').activeItem;
        },
    },
}
